import { Tunings } from '../../../enums/Tunings';
import './TuningCard.css'

interface TuningCardProps {
    type?: Tunings;
    name: string;
    image: string;
    isDonate?: boolean;
    onSelect?: () => void;
}


export const TuningCard = (props: TuningCardProps) => {
    return (
        <div className={`tuning-card ${props.isDonate ? 'donate' : ''}`} onClick={props.onSelect}>
            <div className={`tuning-card-content ${props.isDonate ? 'donate' : ''}`}>
                <div className="tuning-card-content-header">
                    <h1 className="tuning-card-name">{props.name}</h1>
                </div>
                <div className="tuning-card-content-body">
                    <img 
                        className="tuning-card-image" 
                        src={`/icons/tunings/${props.image}.png`} 
                    />
                </div>
                <div></div>
            </div>
        </div>
    )
}
